import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-1"
}

import { computed } from "vue";
import { useSistemaAleman } from "@/composables/useSistemaAleman";
import { calcularPuntosAleman } from "@/utils/sistemaAleman";

// El resultado que se está metiendo en el formulario

export default /*#__PURE__*/_defineComponent({
  __name: 'AvisoSistemaAleman',
  props: {
    resultado1: {},
    resultado2: {}
  },
  setup(__props: any) {

const props = __props;

const aleman = useSistemaAleman();

// Lo que dará en puntos alemanes, en cuanto estén los dos
const puntos = computed(() => {
  const { resultado1: r1, resultado2: r2 } = props;
  if (typeof r1 !== "number" || typeof r2 !== "number") return null;
  if (Number.isNaN(r1) || Number.isNaN(r2)) return null;
  return calcularPuntosAleman(r1, r2);
});

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_unref(aleman))
    ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        type: "info",
        variant: "tonal",
        density: "compact",
        class: "mb-4 text-body-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Este torneo usa el sistema alemán: mete el resultado real de la partida, no los puntos alemanes. Los calcula la app. "),
          (puntos.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createTextVNode(" Con este resultado: "),
                _createElementVNode("strong", null, _toDisplayString(puntos.value.jugador1) + " : " + _toDisplayString(puntos.value.jugador2), 1),
                _createTextVNode(" en el sistema alemán. ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})